export var createMuiDialogActionsOverrides = function (_a) {
    var spacing = _a.spacing;
    return {
        styleOverrides: {
            root: {
                padding: spacing(3, 5, 5, 5),
            },
        },
    };
};
